<svelte:options tag="winners-details"  accessors />
<svelte:window on:load={() => console.log('DOM loaded')} />
<script>
    import { onMount } from "svelte";
    import Utils from './utils';
    import Button from "./Components/Button.svelte";

    const urlParams = new URLSearchParams(window.location.search);
    const isW = urlParams.has('w') || window.location.pathname.split('/')[2] != undefined;
    let loaded = false;
    let nomination = {};
    let root = null;
    let initCarousel = null;
    let listadoUrl = process.env === 'production'?'https://www.fiapawards.com/ganadores/':'http://localhost:40739/';
    let video;
    let hasRelated;

    onMount(async function () {
		const response = await fetch(
			process.env === 'production'?"https://admin.produfiap.com/nominations/getwinnersall":"http://localhost:3030/nominations/getwinnersall"
		);
		const data = await response.json();

        if (isW) {
		    loaded = true;
            const paramId = window.location.pathname.split('/')[2];
            const id = urlParams.get('w') || paramId;
            const years = Object.keys(data);

            years.map(y => {
                if (data[y].nominations != undefined) data[y].nominations.map(n => n.year = y);
            })

            const nominations = years.reduce((acc, year) => {
                return acc.concat(data[year]?.nominations || []);
            }, []);

            nomination = nominations.find(n => n._id === id);
            if (nomination != undefined && nomination.images != undefined && nomination.images.length > 1) {
                initCarousel = runCarousel();
            }
        }
        root = document.querySelector('winners-details').shadowRoot;
        if (nomination.videos[0] != undefined) {
            video = nomination.videos[0].url.split('/');
            video = video[video.length - 1]?video[video.length - 1]:'';
        }
        const rq = await makeRequest(nomination._id);
        if (rq.status != undefined) {
            hasRelated = rq.status == '200'?true:false;
        }
	});

    const navigate = (e) => {
        if (!e.target.classList.contains('active')) {
            const d = parseInt(e.target.getAttribute('data-slide-to'));
            navigateTo(d);
        }
    };

    const showPrev = () => {
        let d = parseInt(root.querySelector('.carousel-inner .item.active').getAttribute('data-slide-to'));
        const items = root.querySelectorAll('.carousel-inner .item');
        d--;
        if (d < 0) d = items.length - 1;
        navigateTo(d);
    };

    const showNext = () => {
        let d = parseInt(root.querySelector('.carousel-inner .item.active').getAttribute('data-slide-to'));
        const items = root.querySelectorAll('.carousel-inner .item');
        d++;
        if (d >= items.length) d = 0;
        navigateTo(d);
    };

    const navigateTo = (slide) => {
        const items = root.querySelectorAll('.carousel-inner .item');
        const indicators = root.querySelectorAll('ol.carousel-indicators li');
        [...indicators].map(item => {
            item.classList.remove('active');
        });
        [...items].map(item => {
            item.classList.remove('active');
        });
        const slide_element = root.querySelector('.carousel-inner .item[data-slide-to="'+slide+'"]');
        if (typeof(slide_element) != 'undefined' && slide_element != null){
            root.querySelector('.carousel-inner .item[data-slide-to="'+slide+'"]').classList.add('active');
        }

        const indicator_element = root.querySelector('ol.carousel-indicators li[data-slide-to="'+slide+'"]');
        if (typeof(indicator_element) != 'undefined' && indicator_element != null){
            root.querySelector('ol.carousel-indicators li[data-slide-to="'+slide+'"]').classList.add('active');
        }
    };

    const runCarousel = () => {
        return setInterval(function() {
            showNext();
        }, 10000);
    };

    const clearTimeOut = () => {
        clearTimeout(initCarousel);
    };

    const initTimeOut = () => {
        if (nomination != undefined && nomination.images != undefined && nomination.images.length > 1) {
            initCarousel = runCarousel();
        }
    };

    const makeRequest = async  (nomination_id) => {
        const url = process.env == 'production'?'https://backend.produ.com/admin/index.php/welcome/getRelatedNews':'http://127.0.0.1:8083/admin/index.php/welcome/getRelatedNews';
        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({id: nomination_id})
        });
        const content = await rawResponse.json();
        return content;
    }

    const myUrl = myurl;
    const loading = process.env === 'production'?`${myUrl}/images/loading.gif`:"./images/loading.gif";
</script>
<main>
    {#if !loaded}
        <div class="row">
            <div class="col-sm-12 text-center"><img class="loading" src="{loading}" alt="loading..."></div>
        </div>
    {:else}
        {#if nomination != undefined}
            <div class="section-fiap-winners">
                <div class="container">
                    <div class="sec-filter">
                        <div class="row">
                            <div class="col-md-offset-2 col-md-8" style="padding-bottom: 20px;">
                                <a href="https://www5.smartadserver.com/ac?jump=1&nwid=1279&siteid=404538&pgname=detalle_ganadores&fmtid=75908&visit=m&tmstp=[timestamp]&out=nonrich" target="_blank">
		                        <img src="https://www5.smartadserver.com/ac?out=nonrich&nwid=1279&siteid=404538&pgname=detalle_ganadores&fmtid=75908&visit=m&tmstp=[timestamp]" border="0" alt="" /></a>
                            </div>
                            <div class="col-md-offset-2 col-md-8">
                                <div style="padding-bottom: 20px; text-align: left;">
                                    <Button redirectUrl={listadoUrl+'?y='+nomination.year} title="&#11013; Volver" />
                                </div>
                            </div>
                            <div class="col-md-offset-2 col-md-8">
                                <div class="title-img">
                                    <h4>{nomination.medal}</h4>
                                    <h6>
                                        {nomination.categoryName}
                                        {#if nomination.medal != 'Gran Sol' && nomination.medal != 'Mención Especial' }
                                            {nomination.subCategory?"/ "+nomination.subCategory:''}
                                        {/if}
                                    </h6>
                                </div>
                                {#if video != undefined}
                                    <div class="carousel slide">
                                        <div style="padding:56.25% 0 0 0;position:relative;">
                                            <iframe
                                                title={nomination.name}
                                                src={"https://player.vimeo.com/video/"+video}
                                                frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style="position:absolute;top:0;left:0;width:100%;height:100%;">
                                            </iframe>
                                        </div>
                                    </div>
                                {:else}
                                    <div id="myCarousel" class="carousel slide" data-ride="carousel" on:mouseover={clearTimeOut} on:focus={clearTimeOut} on:mouseleave={initTimeOut}>
                                        {#if nomination.images != undefined && nomination.images.length > 1}
                                            <!-- Indicators -->
                                            <ol class="carousel-indicators">
                                                {#each nomination.images as image, i}
                                                    <li on:click={navigate.bind(this)} data-target="#myCarousel" data-slide-to="{i}" class="{i == 0?'active':''}"></li>&nbsp;
                                                {/each}
                                            </ol>
                                        {/if}

                                        <!-- Wrapper for slides -->
                                        <div class="carousel-inner">
                                            {#if nomination.images != undefined && nomination.images.length > 0}
                                                {#each nomination.images as image, i}
                                                    <div class="item {i == 0?'active animated':'animated'}" data-slide-to="{i}">
                                                        <img src="{image.url.replace("s3.amazonaws.com/", "")}" alt="">
                                                    </div>
                                                {/each}
                                            {:else}
                                                <div class="item active" data-slide-to="0">
                                                    <img src="{process.env === 'production'?Utils.getImage(nomination.medal).replace('.', myUrl):Utils.getImage(nomination.medal)}" alt="">
                                                </div>
                                            {/if}
                                        </div>

                                        {#if nomination.images != undefined && nomination.images.length > 1}
                                            <!-- Left and right controls -->
                                            <a class="left carousel-control" href="#myCarousel" data-slide="prev" on:click|preventDefault={showPrev} >
                                                <span class="glyphicon glyphicon-chevron-left"></span>
                                                <span class="sr-only">Previous</span>
                                            </a>
                                            <a class="right carousel-control" href="#myCarousel" data-slide="next" on:click|preventDefault={showNext}>
                                                <span class="glyphicon glyphicon-chevron-right"></span>
                                                <span class="sr-only">Next</span>
                                            </a>
                                        {/if}
                                    </div>
                                {/if}

                                <div class="sec-info-winner">
                                    <h4>{nomination.name}</h4>
                                    <p>{nomination.summary}</p>
                                    <h6><strong>Disciplina: </strong> {nomination.categoryName}</h6>
                                    <h6><strong>Agencia: </strong> {nomination.agencyName}</h6>
                                    <h6><strong>País: </strong> {nomination.commonFields} </h6>
                                    <h6><strong>Cliente: </strong> {nomination.clientName} </h6>
                                    <h6><strong>Producto: </strong> {nomination.name}</h6>
                                    {#if nomination._productoradecontenidos != undefined && nomination._productoradecontenidos != ""}
                                        <h6><strong>Productora: </strong> {nomination._productoradecontenidos} </h6>
                                    {/if}
                                    {#if hasRelated}
                                        <div class="cbutton">
                                            <Button redirectUrl={"https://www.produ.com/fiap/ganadores/"+nomination._id} title="Ver noticias relacionadas" target="_blank" />
                                        </div>
                                    {/if}
                                </div>
                            </div>
                            <div class="col-md-offset-2 col-md-8" style="padding-top: 20px;">
                                <a href="https://www5.smartadserver.com/ac?jump=1&nwid=1279&siteid=404538&pgname=detalle_ganadores&fmtid=75909&visit=m&tmstp=[timestamp]&out=nonrich" target="_blank">
		                        <img src="https://www5.smartadserver.com/ac?out=nonrich&nwid=1279&siteid=404538&pgname=detalle_ganadores&fmtid=75909&visit=m&tmstp=[timestamp]" border="0" alt="" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <div class="container">
                <h1 class="h1404">404</h1>
                <h3>Hmm, the page you're looking for can't be found.</h3>
            </div>
        {/if}
    {/if}
</main>

<style global>
    /* Falta resolver los import dependiendo del process.env */

    /* @import "./css/bootstrap.min.css";
    @import "./css/fiap.css";
	@import "./css/global.css"; */

    @import "../assets/js/winners-components/detail/css/bootstrap.min.css";
	@import "../assets/js/winners-components/detail/css/fiap.css";
	@import "../assets/js/winners-components/detail/css/global.css";

    main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
        color: #333;
        box-sizing: border-box;
        font-family: 'Open Sans', sans-serif;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

    @media (max-width: 639px) {
		main {
			max-width: none;
		}
	}

    .h1404 {
        font-size: 72px;
    }

    .animated {
        animation: fadeIn 1s;
    }

    @keyframes fadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
    }

    .title-img {
        text-align: left;
    }

    img.loading {
        width: 200px;
    }

    .cbutton {
        margin-top: 10px;
    }
</style>